module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.fee66e71.woff";